<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <!-- Header компонент -->
    <Header />
    
    <!-- Контент с sidebar -->
    <div class="flex flex-1">
      <!-- Sidebar -->
      <Sidebar 
        :is-mobile-menu-open="isMobileMenuOpen"
        @close-mobile-menu="closeMobileMenu"
      />
      
      <!-- Основной контент -->
      <div class="flex-1 lg:pl-64">
      <!-- Мобильная кнопка меню -->
      <div class="lg:hidden bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <h2 class="text-lg font-medium text-gray-900">{{ currentPageTitle }}</h2>
        <button
          class="p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
          @click="toggleMobileMenu"
        >
          <Bars3Icon class="w-6 h-6" />
        </button>
      </div>
      
      <main class="py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <!-- Breadcrumbs или заголовок секции -->
          <div class="mb-6">
            <nav class="flex items-center space-x-4 text-sm">
              <router-link
                to="/account/dashboard"
                class="text-gray-500 hover:text-gray-700"
              >
                Личный кабинет
              </router-link>
              <ChevronRightIcon class="h-4 w-4 text-gray-400" />
              <span class="text-gray-900 font-medium">{{ currentPageTitle }}</span>
            </nav>
          </div>
          
          <!-- Слот для контента страниц -->
          <slot />
        </div>
      </main>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ChevronRightIcon, Bars3Icon } from '@heroicons/vue/24/outline'
import Header from '@/components/layout/Header.vue'
import Sidebar from '@/components/layout/Sidebar.vue'

// Reactive state
const isMobileMenuOpen = ref(false)

// Composables
const route = useRoute()

// Computed
const currentPageTitle = computed(() => {
  const titleMap: Record<string, string> = {
    '/account/dashboard': 'Обзор',
    '/account/api-keys': 'API-ключи',
    '/account/billing': 'Биллинг',
    '/account/settings': 'Настройки',
  }
  
  return titleMap[route.path] || 'Личный кабинет'
})

// Methods
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
}
</script> 